import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const Search = ({ updateSearchContent, searchContent }) => {
  const [search, setSearch] = useState("");

  const OnchangeHandler = (e) => {
    const content = e.target.value;
    setSearch(content);
  };

  const onClickHandler = () => {
    if (search !== "" && search.trim() !== "") {
      updateSearchContent(search);
    } else {
      toast.warn("Please add search content..");
    }
  };

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter") {
      onClickHandler();
    }
  };

  useEffect(() => {
    if (searchContent === "") {
      setSearch("");
    }
  }, [searchContent]);

  return (
    <div className="d-flex col-4 align-items-center border rounded-2">
      <input
        name="searchBox"
        type="text"
        className="form-control rounded-0 rounded-start-1 shadow-none"
        placeholder="Search by manuscript id  or submission tittle"
        value={search}
        onChange={OnchangeHandler}
        onKeyDown={onKeyDownHandler}
      />
      <button className="btn btn-primary rounded-0" onClick={onClickHandler}>
        <i className="bi bi-search"></i>
      </button>
    </div>
  );
};

export default Search;
